import { Dispatch } from 'react'
import { IPartialPursuit } from 'types'
import { PursuitsPageState } from './store/State'
import { PursuitsPageAction, setPursuit, setEdit, deletePursuit } from './store/Actions'
import { IResponseUpdateRequestPayload } from 'types'

export default class MoreAboutMeService {
  static handleUpdatePursuit(
    state: PursuitsPageState,
    updateResponse: (payload: IResponseUpdateRequestPayload) => Promise<void>
  ) {
    return async () => {
      if (state.passions.every(passion => (passion.title && passion.detail) || (!passion.title && !passion.detail))) {
        await updateResponse({
          questionKey: 'passions',
          response: state.passions.filter(passion => passion.title && passion.detail)
        })
      }
    }
  }

  static handleChangePursuit(dispatch: Dispatch<PursuitsPageAction>) {
    return ({ index, questionKey, response }: IPartialPursuit) => {
      dispatch(setPursuit({ index, questionKey, response }))
    }
  }

  static handleSetEdit(dispatch: Dispatch<PursuitsPageAction>) {
    return (payload: { [key: number]: boolean }) => {
      dispatch(setEdit(payload))
    }
  }

  static deletePursuit(dispatch: Dispatch<PursuitsPageAction>) {
    return (payload: number) => {
      dispatch(deletePursuit(payload))
    }
  }
}
